import { Product } from "./models";

export class SessionProduct extends Product{
    sessionProductId: number;
    productId: number;
    workflowId: number;
    siteId: number;
    capacity: number;
    schedulerId: number;
    sessionGroupId: number;
    price: number;
    startDateTime: string;
    endDateTime: string;
    duration: number;
    totalQuantity: number;
    isActive: boolean;
    bookingStatus: number;
    productDetails: ProductDetail[]
    startDateTimeStr: string;
    endDateTimeStr: string;
    sessionname: string;
    isSiteCapacity: boolean;
    productType: string;
    quantity: number;
    sessionProductGroupDetailsList: [];
    timeZone: TimeZone;
}

export class ProductDetail {
    sessionProductId: number;
    productDetaild: number;
    productId: number;
    price: number;
    quantity: number;
    isActive: boolean;
    itemObjectId: number;
    productType: string;
    productGroupQuantity: number;
    bookingStatus: number;
    lineItems: LineItem[];
}

export class LineItem {
    lineItemId: number;
    sessionProductId: number;
    productDetaild: number;
    firstName: string;
    lastName: string;
    age: number;
    isWaiverRequired: boolean;
    waiverId: number;
    isActive: boolean;
    isCheckedIn: boolean;
}

export class TimeZone {
    timeZoneId: number;
    timeZoneOffset: number;
    timeZoneName: string;
    principleCities: string;
    timeZoneStandard: string;
    timeZoneCurrentDate: Date;
    timeZoneCurrentDateStr: string;
    isActive: boolean;
    isDeleted: boolean;
    updatedBy: number;
    updatedOn: Date;
    createdOn: Date;
    createdBy: number;
    isSuccess: boolean;
    message: string;
}   